import type { NotificationChannel } from '../../services/adminApi';
import type { ExchangeSenderRegistration } from '../../services/tenantApi';

export function notificationChannelTargetLabel(
  channel: NotificationChannel,
  senders: readonly ExchangeSenderRegistration[],
): string {
  const label = `${channel.name} (${channel.channelType})`;
  if (channel.channelType.toLowerCase() !== 'email') return label;
  let provider: unknown;
  try { provider = JSON.parse(channel.configJson).emailProvider; } catch { return label; }
  if (typeof provider !== 'string' || provider.toLowerCase() !== 'microsoftgraph') return label;
  const sender = senders.find(item => item.senderIdentityId.toLowerCase() === channel.emailSenderIdentityId?.toLowerCase());
  return sender
    ? `${label} - Microsoft Graph: ${sender.mailboxName} / ${sender.label} <${sender.fromAddress}>`
    : `${label} - Microsoft Graph: Saved sender unavailable`;
}